"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const logger_1 = require("@azure/logger");
/**
 * The \@azure/logger configuration for this package.
 */
exports.logger = (0, logger_1.createClientLogger)("opentelemetry-instrumentation-azure-sdk");
//# sourceMappingURL=logger.js.map